import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { getThemeFontColor } from '../utils';

export type HelperTextProps = {
  disabled?: boolean;
  hasError?: boolean;
};

const style = ({ disabled, hasError }: HelperTextProps) => {
  return css`
    color: ${getThemeFontColor({ disabled, hasError, theme })};
    display: inline-block;
    font-size: ${theme.fontSize(12)};
    line-height: 1.33;
    padding-top: ${theme.spacing(1)};
    white-space: normal;
  `;
};

export const HelperTextStyles = {
  helperText: (helperTextProps: HelperTextProps) => style(helperTextProps),
};
